module.exports = __webpack_public_path__ + "img/sun-cloud-snow.a18f60a.svg";